export function inputChangeHandler(event: Event): string {
    return (event === null || event.target === null)
        ? ""
        : (<HTMLInputElement>event.target).value;
}